export const MAX_TERRITORIES_LENGTH_WITHOUT_PAGINATION = 50;
